module.exports = __webpack_public_path__ + "static/img/row-right.82ef04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row-right.png
// module id = Bbab
// module chunks = 12